import { createFileRoute } from '@tanstack/react-router';

import { i18n } from '~/utils';
import { getRouteHead } from '~/utils/routeUtils';

const title = i18n.t(($) => $.form.pageTitle.create, { ns: 'contract' });

export const Route = createFileRoute(
  '/(main)/demand/contracts/create/items/$itemId/',
)({
  head: () => getRouteHead(title, 'Erstelle einen neuen Vertrag in VESTIGAS'),
  staticData: {
    AppBar: {
      title,
    },
  },
});
